import { format, parseISO, isValid } from "date-fns";

// import React from "react";
// import { Document, Page } from "react-pdf";
// import "react-pdf/dist/esm/Page/AnnotationLayer";

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function isTeacherUser(user) {
  const positions = [
    ...(user?.positions || []),
    ...(user?.staff_positions || []),
  ];
  return positions.some(
    (p) => String(p?.code || "").toUpperCase() === "TEACHER"
  );
}

// A regional coordinator's post sits on a REGION org; the backend scopes every
// read to that region's schools. These are the only pages they open: the
// schools module down to a class and a pupil's profile in it, but not
// /my-school itself, which answers for the post's own organization.
export const REGION_SCOPE_PATHS = [
  "/home",
  "/schools",
  "/school",
  "/my-school/class",
  "/meetings",
  "/risk-group",
];

export function isRegionUser(user) {
  return user?.current_organization?.type === "region";
}

/**
 * `is_student` comes straight from `/auth/me` — it is true when the account has
 * an active STUDENT group membership. The role code is a second signal, for
 * accounts carrying the role without a live membership.
 *
 * Either signal alone is enough on purpose: reading a staff member as a student
 * only softens a test title, while the reverse shows a child a clinical one.
 */
export function isStudentUser(user) {
  if (user?.is_student === true) return true;
  return (user?.roles || []).some(
    (r) => String(r?.code || "").toLowerCase() === "student"
  );
}

// export function showImageOrPdf(docUrl, heightOfDoc) {
//   if (docUrl?.substr(docUrl?.length - 4) === ".pdf") {
//     return (
//       <div className={""}>
//         <Document file={docUrl}>
//           <Page
//             pageNumber={1}
//             renderTextLayer={false}
//             renderAnnotationLayer={false}
//             height={heightOfDoc * 16}
//           />
//         </Document>
//       </div>
//     );
//   }

//   if (docUrl) {
//     return (
//       <React.Fragment>
//         <div className={""}>
//           <Document file={docUrl}>
//             <Page
//               pageNumber={1}
//               renderTextLayer={false}
//               renderAnnotationLayer={false}
//               height={heightOfDoc * 16}
//             />
//           </Document>
//         </div>

//         <img className="h-[8rem] object-cover" src={docUrl} alt="doc" />
//       </React.Fragment>
//     );
//   }

//   return <div className="italic">no image</div>;
// }

export const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  try {
    const raw = String(dateStr);
    const normalized = raw.includes("T") ? raw.split("T")[0] : raw.split(" ")[0];
    const date = parseISO(normalized);
    if (!isValid(date)) return dateStr;
    return format(date, "dd.MM.yyyy");
  } catch {
    return String(dateStr);
  }
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return "-";
  try {
    const date = typeof dateStr === "string" ? parseISO(dateStr) : new Date(dateStr);
    if (!isValid(date)) return "-";
    return format(date, "dd.MM.yyyy HH:mm");
  } catch {
    return String(dateStr);
  }
};

/**
 * Reorder an array by moving an item from startIndex to endIndex.
 * Used by react-beautiful-dnd drag-and-drop handlers.
 */
export const drugReorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const ZONE_TRANSLATION_KEYS = {
  green_zone: "zones.green_zone",
  yellow_zone: "zones.yellow_zone",
  orange_zone: "zones.orange_zone",
  red_zone: "zones.red_zone",
};

export const getZoneName = (zoneCode, t) => {
  const key = ZONE_TRANSLATION_KEYS[zoneCode];
  return key ? t(key) : zoneCode || "";
};
